export default {
  feedback: {
    login_success: 'Kirjautuminen onnistui',
    logout_success: 'Uloskirjautuminen onnistui',
  },
};
